import "../App.css";
import { useAuth } from "../contexts/AuthContext";
import LoggedInHeader from "./LoggedInHeader";
import { Container, Row, Col } from "react-bootstrap";

function CEUStatement() {
  const { currentUser } = useAuth();

  return (
    <div>
      { currentUser && <LoggedInHeader /> }
      <Container>
        <Row>
          <Col className="ceustatement d-flex flex-column justify-content-center">
            <div className="header">CEU Statement</div>
            <div className="body">
              <p>Continuing education credit for CTGWeb2.0 is awarded on a module-by-module basis. However, all modules of the course must be completed to receive any credit and the certificate of completion. The certificate of completion is available for download after submitting the course evaluation.</p>
            </div>
            <div className="sub-header">South Carolina</div>
            <div className="body">
              <p>The Medical University of South Carolina (MUSC) is an approved provider of continuing education for South Carolina mental health professionals. This online training course, CTGWeb2.0, has been approved for 6 contact hours of continuing education.</p>
            </div>
            <div className="sub-header">National Board for Certified Counselors (<a href="https://www.nbcc.org" target="_blank" rel="noopener noreferrer">nbcc.org</a>)</div>
            <div className="body">
              <p>The National Crime Victims Research and Treatment Center at MUSC has been approved by NBCC as an Approved Continuing Education Provider, ACEP No. 6512. Programs that do not qualify for NBCC credit are clearly identified.</p>
              <p>Unfortunately, we cannot provide authoritative answers about acceptance of continuing education credit/hours awarded for CTGWeb2.0 for all professions in every state. Learners should review their state licensing board documentation to make their own determination about recognition of CE credit from this course.</p>
              <p>If you have other questions regarding continuing education or certificates of completion for this course, please contact our customer service at <a href="mailto:ctgweb@musc.edu">ctgweb@musc.edu</a>.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CEUStatement;